import { Button, Modal, Row, Table } from 'antd'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { CheckInQrModal } from 'src/components/userProfile/CheckInQrModal'
import {
  TICKET_ADDRESS,
  TICKET_NAME,
  TICKET_START_TIME,
  TICKET_STATUS,
  TICKET_STATUS_NAME,
} from 'src/services/api/constant'
import { apiOrderHistories } from 'src/store/sagas/payment'
import { formatCurrency } from 'src/utils/helper'
import addNotification, { NOTIFICATION_TYPE } from 'src/utils/toast'
import styled from 'styled-components'

export const ModalStyled = styled(Modal)`
  border-radius: 20px;
  color: #ffffff;
  .ant-modal-header {
    background: transparent;
  }
  .ant-modal-content {
    background: #fff;
  }

  ::placeholder {
    color: #757575;
    font-size: 14px;
    font-weight: 400;
  }
`
export const Histories = () => {
  const token = localStorage.getItem('access_token')
  const userInfo = JSON.parse(localStorage.getItem('user_info'))

  if (!token) {
    window.location.replace('/')
  }

  const [data, setData] = useState([])
  const [openPopupQr, setOpenPopupQr] = useState(false)
  const [qrData, setQrData] = useState('')
  const [openCheckInQrModal, setOpenCheckInQrModal] = useState(false)
  const [ticketIds, setTicketIds] = useState([])

  const [page, setPage] = useState(1)
  const [totalItem, setTotalItem] = useState(0)
  const [limit, setLimit] = useState(10)

  useEffect(() => fetchHistories(), [])

  const fetchHistories = async (pageSelect, limitSelect) => {
    const query = {
      filter: JSON.stringify([
        {
          column: 'email',
          text: userInfo.email,
        },
      ]),

      page: pageSelect || page,
      limit: limitSelect || limit,
    }
    const response = await apiOrderHistories(query)
    if (response.statusCode === 200) {
      const dataTable = response.data.items
      setData(dataTable)
      setTotalItem(response.data.meta.total)
    } else {
      addNotification(
        response.message,
        NOTIFICATION_TYPE.ERROR,
        'Có lỗi xảy ra!',
      )
    }
  }

  const viewCheckInQr = (ticketIds) => {
    setTicketIds(ticketIds)
    setOpenCheckInQrModal(true)
  }

  const handleChangePage = (page, pageSize) => {
    fetchHistories(page, pageSize)
    setPage(page)
    setLimit(pageSize)
  }

  const columns = [
    {
      title: 'Tên Sự kiện',
      dataIndex: 'name',
      key: 'name',
      render: (_, record) => (record ? TICKET_NAME[record.eventCode] : null),
    },
    {
      title: 'Ngày diễn ra',
      render: (_, record) =>
        record ? TICKET_START_TIME[record.eventCode] : null,
    },
    {
      title: 'Địa chỉ',
      render: (_, record) => (record ? TICKET_ADDRESS[record.eventCode] : null),
    },
    {
      title: 'Số ghế',
      dataIndex: 'seat',
      key: 'seat',
      render: (_, record) => record?.seat?.map((item) => item).join(', '),
    },
    {
      title: 'Giá',
      dataIndex: 'amount',
      key: 'amount',
      render: (_, record) => formatCurrency(record?.amount || 0),
    },
    {
      title: 'Thời gian đặt',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record) =>
        record ? moment(record?.createdAt).format('HH:mm:ss DD/MM/YYYY') : null,
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      key: 'status',
      render: (_, record) =>
        record ? TICKET_STATUS_NAME[record.status] : null,
    },
    {
      title: 'QR check in',
      dataIndex: 'checkInQrCode',
      key: 'checkInQrCode',
      render: (_, record) => (
        <>
          {record.status !== TICKET_STATUS.APPROVE && "Chờ thanh toán"}
          {record.status === TICKET_STATUS.APPROVE && (
            <Button type="primary" onClick={() => viewCheckInQr(record?.ticketIds)}>
              Xem QR check in
            </Button>
          )}
        </>
      ),
    },
  ]

  return (
    <>
      <Row gutter={24} className="mt-2">
        <div className="bg-[#fff] pt-2 w-full">
          <Table
            scroll={{ x: 500 }}
            className="w-full text-black"
            columns={columns}
            dataSource={data}
            pagination={{
              current: page, // Trang hiện tại
              pageSize: limit, // Số hàng trên mỗi trang
              total: totalItem || 0, // Tổng số hàng
              onChange: (page, pageSize) => handleChangePage(page, pageSize),
              showSizeChanger: true, // Hiển thị tùy chọn thay đổi số hàng trên mỗi trang
              pageSizeOptions: ['10', '20', '50'],
            }}
          />
        </div>
      </Row>
      <ModalStyled
        open={openPopupQr}
        closable={true}
        onCancel={() => {
          setOpenPopupQr(false)
          setQrData('')
        }}
        footer={null}
        wrapClassName="!bg-[#00000070]"
        className="relative"
      >
        <div className="w-full p-4 flex">
          <img src={qrData} className="w-full" alt='qrData' />
        </div>
      </ModalStyled>
     { openCheckInQrModal && <CheckInQrModal 
        ticketIds={ticketIds} 
        openCheckInQrModal={openCheckInQrModal} 
        setOpenCheckInQrModal={setOpenCheckInQrModal} 
      />}
    </>
  )
}
